class VersionService {
	static getVersion() {
		window.fetch('/package.json')
		.then(function(response) {
			return response.json();
		}).then(function(json) {
			console.log(json.version);
		}).catch(function(ex) {
			console.log('parsing failed', ex);
		});
	}
}

export default VersionService;


// WEBPACK FOOTER //
// ./resources/WEB-INF/script/service/service.version.es6.js